/**
 * Registration user details translation keys
 */
export const REGISTRATION_USER_DETAILS_TITLE_TRANSLATION_KEY =
  'registration_user_details_title';
export const REGISTRATION_USER_DETAILS_INFO_TRANSLATION_KEY =
  'registration_user_details_info';
export const REGISTRATION_USER_DETAILS_LINK_TRANSLATION_KEY =
  'registration_user_details_link';
